import React from 'react';
import { Route } from 'react-router';
import { push } from 'react-router-redux';
import { logout } from '../../core/actions/user/logout';
import { getStore } from '../store';
import { fetchInstitution } from '../../core/actions/institutions';

const redirectToGeneral = () => {
  if (window.location.href.includes('localhost')) {
    return window.location.replace('http://localhost:8888/#/select');
  }
  return window.location.replace('https://general.aula.education/#/select');
};

const logoutRoute = (
  <Route
    path="logout"
    onEnter={({ location }) => {
      const store = getStore();
      store.dispatch(logout()).then((err) => {
        if (err) {
          console.log('had some error');
        }
        localStorage.clear();
        // const fetchInstitutionPromise = store.dispatch(fetchInstitution());
        // fetchInstitutionPromise.then(() => {
        //   const redirectTo = location.query.redirect || '/signin/login';
        //   store.dispatch(push(redirectTo));
        // });

        redirectToGeneral();
      });
    }}
  />
);

export default logoutRoute;
